/* eslint-disable import/prefer-default-export */
import _ from "underscore";
import { replaceById } from "@exo/helpers";

// if an object has id: "allTracked", add all of the other objects' ids in element 'group'
//	objArr: [{ id: string }] // NOTE: "group" will be overwritten if obj.id: "allTracked"
// Mutates objArr
export const groupAllTracked = (objArr) => {
	const groupObj = _.find(objArr, (obj) => obj.id === "allTracked");

	if (groupObj) {
		const ids = [];

		_.each(objArr, (obj) => {
			if (obj.id !== "all" && obj.id !== "allTracked") {
				ids.push(obj.id);
			}
		});

		groupObj.group = ids;

		return replaceById({ array: objArr, id: "allTracked", replacementObj: groupObj });
	} else {
		return objArr;
	}
};
